<template>
	<div id="idFrameBody" ref="idFrameBody" style="width:100%; display:flex; flex-direction: row; border:0px solid #ff0000;">
		<div style="flex:1 0 auto; border:0px solid red;">
			<div style="height:100%; display:flex; flex-direction: column;">
				<div style="flex:0 0 auto; border:0px solid red; height:10px;" ref="idBodySplit1"></div><!--���������ϲ�����-->
				<div style="flex:1 1 auto; border:1px solid #e1e1e1; overflow:hidden;" id="idOPBody" ref="idOPBody">
					<router-view></router-view>
				</div>
				<div style="flex:0 0 auto; border:0px solid red; height:10px;" ref="idBodySplit2"></div><!--���������²�����-->
			</div>
		</div>
		<div style="flex:0 0 auto; border:0px solid red; width:10px;"></div><!--���������Ҳ�����-->
	</div>
</template>

<script>

export default {
	name: 'FrameBody',
	components:{

	},
	data () {
		return {
			frameBodyHeight: 0,
			frameBodyWidth: 0,
		}
	},
	watch:{

	},
	mounted: function(){
		console.log( "FrameBody mounted");
	},
	computed:{

	},
	methods:{
		onResize: function(){
			let obj1=this.$refs["idFrameBody"];
			let obj2=this.$refs["idOPBody"];

			let formW=this.$parent.formW;                      //���ڵĿ���
			let lftMenuW=this.lftMenu.widthNormal;             //���˵��Ŀ���
			let border1W=15;                                   //������3������ָ����Ŀ���
			let border2W=12;                                   //���������������(���˵�����չ����ť��)
			let border3W=10;                                   //���������Ҳ�����

			if( !this.lftMenu.show ) lftMenuW=this.lftMenu.widthHide;     // ��ʱֻ��������һ����
			if( this.$parent.$refs["idFormLeft"].style["display"] == "none" )    lftMenuW = 0;    // �������˵�������
			if( this.$parent.$refs["idMenuHidePan"].style["display"] == "none" ) border2W = 0;    // �������������������

			obj2.style["width"] = ( formW - lftMenuW - border1W - border2W - border3W)+"px";

			let formH=this.$parent.formH;                      //�������ڵĸ߶�
			let topH=this.$parent.topHeight;                   //����topbar�߶�
			let border1H=10;                                   //�����ں���ָ�����(2��)�߶�
			let border3H=20;                                   //���������������׵�(����)�߶�

			if( this.$parent.$refs["idFormTop"].style["display"] == "none" ) topH = 0;                 // �����˵�������ʱ
			if( this.$refs["idBodySplit1"].style["display"] == "none" )      border3H = border3H-10;   // �ϲ�����
			if( this.$refs["idBodySplit2"].style["display"] == "none" )      border3H = border3H-10;   // �²�������

			this.frameBodyHeight = ( formH - topH - border1H);
			obj1.style["height"] = ( formH - topH - border1H)+"px";
			obj2.style["height"] = ( formH - topH - border1H - border3H )+"px";

			this.childResize( this );
		},
		fullBody: function( flag, clr ){
			if( flag )
			{
				this.$refs["idBodySplit1"].style["display"] = "none";
				this.$refs["idBodySplit2"].style["display"] = "none";
				this.$refs["idFrameBody"].style["background"] = clr;
				this.$refs["idOPBody"].style["border"] = "0px";
			}
			else
			{
				this.$refs["idBodySplit1"].style["display"] = "block";
				this.$refs["idBodySplit2"].style["display"] = "block";
				this.$refs["idFrameBody"].style["background"] = "#ffffff";
				this.$refs["idOPBody"].style["border"] = "1px solid #e1e1e1";
			}
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// FrameBody.vue?e7ac434c